
export default {
  methods: {
    getInteractionByName(name) {
      return this.map
        .getInteractions()
        .getArray()
        .find(i => i.get('name') == name);
    },
    getLayerByName(name) {
      return this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get('name') == name;
        });
    }
  }
};
